import { Dialog } from 'primereact/dialog';
import { useEffect } from 'react';
import { useProjectContext } from '@/context/ProjectContext';
import type { Project } from '@/interfaces/projects.interface';
import { ProjectDropdown } from './ProjectDropdown';

export const ProjectSelector = () => {
  const {
    projects,
    loadingProjects,
    selectedProjectId,
    isProjectSelectorVisible,
    setProjectSelectorVisible,
  } = useProjectContext();

  useEffect(() => {
    if (loadingProjects || projects.length === 0) return;

    if (selectedProjectId) {
      const currentProject = projects.find(
        (p: Project) => p.projectId === selectedProjectId
      );
      if (currentProject) {
        setProjectSelectorVisible(false);
      } else {
        setProjectSelectorVisible(true);
      }
    } else {
      setProjectSelectorVisible(true);
    }
  }, [loadingProjects, projects, selectedProjectId, setProjectSelectorVisible]);

  return (
    <Dialog
      visible={isProjectSelectorVisible}
      onHide={() => selectedProjectId && setProjectSelectorVisible(false)}
      header='Select a Project'
      closable={Boolean(selectedProjectId)}
      dismissableMask={Boolean(selectedProjectId)}
      className='w-[400px]'
      headerClassName='text-center text-foreground'
      draggable={false}
      pt={{
        content: { className: 'bg-card text-card-foreground' },
        header: {
          className: 'bg-card text-card-foreground border-b border-border',
        },
      }}
    >
      <ProjectDropdown showClear={true} size='medium' />
    </Dialog>
  );
};
